import account from '../../services/account-service'
import notification from '../../services/notification-service'
import i18n from './../../i18n'

// initial state
const state = () => ({
  receivables: [],
  orders: [],
  user: {}
})

// getters
const getters = {
}

// actions
const actions = {
    async getReceivables ({ commit }) {
        const response = await account.retrieveReceivables()
        response.error ? notification.notify(i18n.t('notifications.oops'), response.readable, "warn") : commit('setReceivables', response.data)
    },

    async getOrderHistory({commit}) {
        const response = await account.retrieveOrderHistory();
        response.error ? notification.notify(i18n.t('notifications.oops'), response.readable, "warn") : commit('setOrderHistory', response.data)
    },

    async getUser({commit}) {
        const response = await account.retrieveUser();
        if (response.error) {
            notification.notify(i18n.t('notifications.oops'), response.readable, "error")
        }  else {
            commit('setUser', response.data)
        } 
        commit('setLanguage')
    }
}

// mutations
const mutations = {
    setReceivables (state, receivables) {
        state.receivables = receivables;
    },

    setOrderHistory (state, orders) {
        state.orders = orders;
    },

    setUser (state, user) {
        state.user = user
    },

    setLanguage(state) {
        if (state.user && state.user.language_short_code) {
            const lang = state.user.language_short_code.toLowerCase()
            localStorage.setItem('retailers-lang', lang)
            i18n.locale = lang
        } else if (localStorage.getItem('retailers-lang')) {
            i18n.locale = localStorage.getItem('retailers-lang')
        } else {
            i18n.locale = 'en'
        }
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}